import React from "react";

const Footer = () => (
  <footer className="bg-light p-3 text-center">
    <div className="logo" />
    <p>
      Travel Planner by <a href="https://lbacreations.com">LBA Créations</a>
    </p>
  </footer>
);

export default Footer;
